import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { ToastrModule } from 'ngx-toastr';

import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule, HttpXsrfTokenExtractor } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '@app/shared/angular-material.module';

import { AppShellComponent } from './components/app-shell/app-shell.component';
import { FooterBarComponent } from './components/footer-bar/footer-bar.component';
import { HeaderBarComponent } from './components/header-bar/header-bar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LogoutModalComponent } from './components/logout-modal/logout-modal.component';
import { MenuHorizontalItemComponent } from './components/menu-horizontal-item/menu-horizontal-item.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuComponent } from './components/menu/menu.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { HttpLoadingInterceptor } from './interceptors/http-loading.interceptor';
import { HttpRetryInterceptor } from './interceptors/http-retry.interceptor';
import { DEFAULT_TIMEOUT, HttpTimeoutInterceptor } from './interceptors/http-timeout.interceptor';
import { HttpXsrfInterceptor, XSRF_COOKIE_NAME, XSRF_HEADER_NAME } from './interceptors/http-xsrf.interceptor';
import { AppConfigurationService } from './services/app-configuration.service';
import { HttpXsrfTokenExtractorService } from './services/http-xsrf-token-extractor.service';
import { SharedModule } from '@app/shared/shared.module';

const appInitializerFn = (appConfig: AppConfigurationService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    LoadingComponent,
    HeaderBarComponent,
    FooterBarComponent,
    AppShellComponent,
    MenuComponent,
    NotFoundComponent,
    LogoutModalComponent,
    MenuItemComponent,
    MenuHorizontalItemComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN'
    }),
    RouterModule,
    FormsModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(35, 31, 32, 0.3)',
      backdropBorderRadius: '0px',
      primaryColour: '#FFFFFF',
      secondaryColour: '#D40511',
      fullScreenBackdrop: true
    }),
    ToastrModule.forRoot({
      tapToDismiss: true,
      closeButton: true,
      preventDuplicates: true,
      newestOnTop: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      timeOut: 3000,
      autoDismiss: true,
      positionClass: 'toast-bottom-full-width',
      toastClass: 'ngx-toastr toast-success dhl-toastr',
      disableTimeOut: true
    }),
    SharedModule
  ],
  exports: [AppShellComponent, LogoutModalComponent, MenuHorizontalItemComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigurationService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpXsrfInterceptor,
      multi: true
    },
    {
      provide: HttpXsrfTokenExtractor,
      useClass: HttpXsrfTokenExtractorService
    },
    {
      provide: XSRF_COOKIE_NAME,
      useValue: 'XSRF-TOKEN'
    },
    {
      provide: XSRF_HEADER_NAME,
      useValue: 'X-XSRF-TOKEN'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true
    },
    {
      provide: DEFAULT_TIMEOUT,
      useValue: 180000
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRetryInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {}
